module.exports = __webpack_public_path__ + "static/media/lock-is-correct.af3a12ef.mp3";